/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmStepExecution {
    getFixupPrototypeFunction() { return AwsSsmStepExecution.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmStepExecution>): AwsSsmStepExecution {
        let obj = Object.assign(new AwsSsmStepExecution(), model);
        AwsSsmStepExecution.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmStepExecution>): AwsSsmStepExecution {
        if (!model) return null;
        return AwsSsmStepExecution.newInstance(<AwsSsmStepExecution> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmStepExecution) {
        if (!obj) return;

        models.AwsSsmStepExecution.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmStepExecution): boolean {
        Object.setPrototypeOf(obj, AwsSsmStepExecution.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.max_attempts === undefined) {
            this.max_attempts = 0;
        }
        if (typeof this.execution_start_time === "string") {
            this.execution_start_time = new Date(<string><any>this.execution_start_time);
        }
        if (typeof this.execution_end_time === "string") {
            this.execution_end_time = new Date(<string><any>this.execution_end_time);
        }
        if (this.failure_details) {
            models.AwsSsmStepFailureDetail.fixupPrototype(this.failure_details);
        }
    }

    /**
     * Id of the Step Execution
     */
    sysId: string;

    /**
     * Id reference of the execution job id
     */
    job_id: string;

    /**
     * Name of the step.
     */
    name: string;

    /**
     * The action this step performs. The action determines the behavior of the step
     */
    action: string;

    /**
     * The action to take if the step fails. The default value is Abort
     */
    on_failure: string;

    /**
     * The maximum number of tries to run the action of the step. The default value is 1
     */
    max_attempts: number;

    /**
     * If a step has begun execution, this contains the time the step started.
     */
    execution_start_time: Date;

    /**
     * If a step has finished execution, this contains the time the execution ended.
     */
    execution_end_time: Date;

    /**
     * Status of the Automation Execution
     */
    status: models.AwsSsmAutomationExecutionStatus;

    inputs: { [key: string]: string; };

    output: { [key: string]: string; };

    /**
     * The unique ID of a step execution. Execution id of the step
     */
    step_execution_id: string;

    overridden_parameters: { [key: string]: string; };

    /**
     * Strategies used when step fails, we support Continue and Abort. Abort will fail the automation when the step fails. Continue will ignore the failure of current step and allow automation to run the next step.
     */
    valid_next_steps: Array<string>;

    /**
     * Failure message of the step of the job.
     */
    failure_message: string;

    /**
     * Information about the Automation failure
     */
    failure_details: models.AwsSsmStepFailureDetail;

}
